import { render, staticRenderFns } from "./StripeFail.vue?vue&type=template&id=d87956d8&"
import script from "./StripeFail.vue?vue&type=script&lang=js&"
export * from "./StripeFail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports